export var cibKirby = ["32 32", "<path d='M16 0l-14.094 8v16l14.094 8 14.099-8v-16zM22.281 16.339l-3.953 2.13v0.292h3.953v3.104h-12.563v-3.083h3.943v-0.302l-3.953-2.141v-3.818l6.292 3.391 6.286-3.396v3.823z'/>"];
